// Дефолтный Validators.email пропускает 'test@te' (нет TLD-проверки).
// Используем единый regex во всех auth-формах. См. UKZ-52.
export const EMAIL_WITH_TLD_PATTERN = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/;
